import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  fetchEventHttpActionLogs: `${NAMESPACE}_EVENT_HTTP_ACTION_LOGS_FETCH`,
  updateEventHttpActionLogs: `${NAMESPACE}_EVENT_HTTP_ACTION_UPDATE_LOGS`,
  setIsLoadingEventHttpLogs: `${NAMESPACE}_EVENT_HTTP_ACTION_SET_IS_LOADING`,
  clearEventHttpActionLogs: `${NAMESPACE}_EVENT_HTTP_ACTION_CLEAR_DATA`,
};

export const actionCreators = {
  fetchEventHttpActionLogs: payload => ({ type: actions.fetchEventHttpActionLogs, payload }),
  updateEventHttpActionLogs: payload => ({ type: actions.updateEventHttpActionLogs, payload }),
  setIsLoadingEventHttpLogs: payload => ({ type: actions.setIsLoadingEventHttpLogs, payload }),
  clearEventHttpActionLogs: () => ({ type: actions.clearEventHttpActionLogs }),
};

export default {
  actions,
  actionCreators,
};
